import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/** Purely decorative — hidden from assistive tech, which gets an aria-live status instead. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}
